import { render, staticRenderFns } from "./ResultBid.vue?vue&type=template&id=189f8772"
import script from "./ResultBid.vue?vue&type=script&lang=js"
export * from "./ResultBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports